import { useEffect, useState } from "react";
import api from "../../api/axios";

import {
  getRendezVous,
  createRendezVous,
  updateRendezVous,
  deleteRendezVous,
  updateEtatRendezVous,
  updateHeursRendezVous
} from "../../api/rendezVousService.api";

import { getClients } from "../../api/clients.api";
import { getEntretiens } from "../../api/typesEntretien.api";

import RendezVousForm from "../../components/RendezVous/RendezVousForm";
import RendezVousTable from "../../components/RendezVous/RendezVousTable";

import "../../components/RendezVous/RendezVous.css";


const RendezVousPage = () => {


  const [rendezVous, setRendezVous] = useState([]);

  const [clients, setClients] = useState([]);

  const [entretiens, setEntretiens] = useState([]);

  const [techniciens, setTechniciens] = useState([]);



  const [editData, setEditData] = useState(null);

  const [formOpen, setFormOpen] = useState(false);



  const [filterClient, setFilterClient] = useState("");

  const [filterMonth, setFilterMonth] = useState("");

  const [filterEtat, setFilterEtat] = useState("");



  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 20;



  // Chargement des données

  const loadData = async () => {

    try {


      const rv = await getRendezVous();

      const cl = await getClients();

      const entretien = await getEntretiens();

      const tech = await api.get("/technicien");



      // TRI GLOBAL : plus récent vers plus ancien

      const sortedRdv = [...rv.data].sort((a,b)=>{


        const dateA = new Date(
          `${a.date_rdv}T${a.heure_debut || "00:00:00"}`
        );


        const dateB = new Date(
          `${b.date_rdv}T${b.heure_debut || "00:00:00"}`
        );


        return dateB - dateA;


      });



      setRendezVous(sortedRdv);

      setClients(cl.data);

      setEntretiens(entretien.data);

      setTechniciens(tech.data);



    } catch(error){

      console.error(
        "Erreur chargement rendez-vous",
        error
      );

    }

  };




  useEffect(()=>{

    loadData();

  },[]);




  useEffect(()=>{

    setCurrentPage(1);

  },[
    filterClient,
    filterMonth,
    filterEtat
  ]);




  // Ajouter client

  const handleClientCreated = (client)=>{

    setClients(prev=>[
      ...prev,
      client
    ]);

  };




  // Ouvrir ajout

  const handleOpenAdd = ()=>{

    setEditData(null);

    setFormOpen(true);

  };




  // Ouvrir modification

  const handleOpenEdit = (rdv)=>{

    setEditData(rdv);

    setFormOpen(true);

  };




  // Création rendez-vous

  const handleCreate = async(data)=>{


    await createRendezVous(data);


    setFormOpen(false);


    loadData();


  };




  // Modification rendez-vous

  const handleUpdate = async(data)=>{


    await updateRendezVous(
      editData.id,
      data
    );


    setEditData(null);

    setFormOpen(false);


    loadData();


  };




  // Suppression

  const handleDelete = async(id)=>{


    if(window.confirm("Supprimer ce rendez-vous ?")){


      await deleteRendezVous(id);


      loadData();


    }


  };
    // Filtrage

  const filteredRdv = rendezVous.filter((rdv)=>{


    const matchClient =

      filterClient

      ? rdv.client_id === Number(filterClient)

      : true;



    const matchMonth =

      filterMonth

      ? rdv.date_rdv.slice(0,7) === filterMonth

      : true;



    const matchEtat =

      filterEtat

      ? rdv.etat_travaux === filterEtat

      : true;



    return (

      matchClient &&

      matchMonth &&

      matchEtat

    );


  });




  // Pagination après tri + filtre

  const totalPages = Math.ceil(

    filteredRdv.length / itemsPerPage

  );



  const paginatedRdv = filteredRdv.slice(

    (currentPage - 1) * itemsPerPage,

    currentPage * itemsPerPage

  );




  const goToPage = (page)=>{


    if(

      page >= 1 &&

      page <= totalPages

    ){

      setCurrentPage(page);

    }


  };




  // Changement état

  const handleChangeEtat = async(

    id,

    newEtat

  )=>{


    try{


      await updateEtatRendezVous(

        id,

        {

          etat_travaux:newEtat

        }

      );



      loadData();



    }catch(error){


      console.error(error);


    }


  };





  // Modification heure fin

  const onEditHeureFin = async(

    id,

    nouvelleHeure

  )=>{


    try{


      await updateHeursRendezVous(

        id,

        {

          heure_fin:nouvelleHeure

        }

      );



      setRendezVous(prev=>

        prev.map(rv=>

          rv.id === Number(id)

          ?

          {

            ...rv,

            heure_fin:nouvelleHeure

          }

          :

          rv

        )

      );



    }catch(error){


      console.error(error);


      alert(
        "Impossible de modifier l'heure de fin"
      );


    }


  };




  return (

    <div className="rendezvous-page">



      <h2>
        Gestion des rendez-vous !
      </h2>




      <button

        onClick={handleOpenAdd}

        className="btn-add"

      >

        Ajouter un rendez-vous

      </button>





      {/* FORMULAIRE AJOUT / MODIFICATION */}


      <div

        className={

          `form-container ${

            formOpen

            ? "open"

            : ""

          }`

        }

      >


        {

          formOpen &&


          <RendezVousForm


            onSubmit={

              editData

              ?

              handleUpdate

              :

              handleCreate

            }



            initialData={editData}



            techniciens={techniciens}



            clients={clients}



            entretiens={entretiens}



            onClientCreated={handleClientCreated}


          />


        }





        {

          formOpen &&


          <button

            onClick={()=>{

              setFormOpen(false);

              setEditData(null);

            }}

            className="btn-close"

          >

            Fermer

          </button>


        }


      </div>







      {/* FILTRES */}


      <div className="filters">



        <select

          value={filterClient}

          onChange={e=>

            setFilterClient(e.target.value)

          }

        >

          <option value="">

            Tous les clients

          </option>



          {

            clients.map(c=>(

              <option

                key={c.id}

                value={c.id}

              >

                {c.nom}

              </option>

            ))

          }


        </select>





        <select

          value={filterEtat}

          onChange={e=>

            setFilterEtat(e.target.value)

          }

        >


          <option value="">

            Tous les états

          </option>


          <option value="EN_ATTENTE">

            En attente

          </option>


          <option value="EN_COURS">

            En cours

          </option>


          <option value="TERMINE">

            Terminé

          </option>


        </select>





        <input

          type="month"

          value={filterMonth}

          onChange={e=>

            setFilterMonth(e.target.value)

          }

        />


      </div>







      {/* TABLEAU */}


      <RendezVousTable


        data={paginatedRdv}



        onEdit={handleOpenEdit}



        onDelete={handleDelete}



        entretiens={entretiens}



        clients={clients}



        techniciens={techniciens}



        onChangeEtat={handleChangeEtat}



        onEditHeureFin={onEditHeureFin}


      />







      {/* PAGINATION */}


      {

        totalPages > 1 &&


        <div className="pagination">



          <button

            onClick={()=>goToPage(currentPage-1)}

            disabled={currentPage===1}

          >

            Précédent

          </button>





          {

            Array.from(

              {length:totalPages},

              (_,i)=>(


                <button

                  key={i+1}


                  className={

                    currentPage===i+1

                    ?

                    "active"

                    :

                    ""

                  }


                  onClick={()=>goToPage(i+1)}

                >

                  {i+1}

                </button>


              )

            )


          }





          <button

            onClick={()=>goToPage(currentPage+1)}

            disabled={currentPage===totalPages}

          >

            Suivant

          </button>



        </div>


      }



    </div>

  );


};


export default RendezVousPage;